import { combineReducers } from "redux";
import tickets from "./tickets";

export default combineReducers({ tickets });
